<template>
	<v-app>
		<layout />
	</v-app>
</template>

<script>
	import { mapActions } from 'vuex';
	import Layout from './components/layout';

	export default {
		name: 'app',

		components: {
			Layout
		},

		data: () => ({}),

		computed: {},

		created() {
			this.getMarketData();
		},

		methods: {
			...mapActions('App', ['getMarketData'])
		}
	};
</script>
